import { 
    TextInput,
    Button,
    Container,
    Center,
    Text,
    Title,
    Card
} from '@mantine/core';
import { 
    IconKey, 
    IconMail 
} from '@tabler/icons-react';

import { useForm } from '@mantine/form';
import { zod4Resolver as zodResolver } from 'mantine-form-zod-resolver';
import { useTranslation } from 'react-i18next';
import { z } from 'zod';
import { useSendResetPasswordUser } from '@/features/auth/api/sendResetPassword';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useViewportSize } from '@mantine/hooks';

const forgotInitValues = {
    username: ''
}

export const ForgotPassword = () => {
    const { t } = useTranslation();
    const { height } = useViewportSize();
    const useSendResetPasswordMutation = useSendResetPasswordUser();

    const schema = z.object({
        username: z.string()
            .email(t('error.invalidEmail'))
            .nonempty(t('error.emailRequired'))
    })

    const [isSuccess, setIsSuccess] = useState(false)
    const [username, setUsername] = useState('');

    const form = useForm({
        initialValues: forgotInitValues,
        validate: zodResolver(schema)
    }) 

    async function handleSubmit(e: React.SyntheticEvent) {
        e.preventDefault();

        const values = form.values;
        const sendResetPasswordObject = {
            username: values.username
        }
        console.debug(sendResetPasswordObject)
        await useSendResetPasswordMutation.mutateAsync({ data: sendResetPasswordObject })
    }

    useEffect(() => {
        if (useSendResetPasswordMutation.isSuccess)
            setIsSuccess(true);
    }, [useSendResetPasswordMutation.isSuccess])

    if (isSuccess) {
        return (
            <Center maw={400} mx="auto" h={height}>
                <Container maw={400}>
                    <Card shadow="sm" padding="lg" radius="md" withBorder mb="md" mt="md">
                        <Center>
                            <IconMail color="blue" size={60} />
                        </Center>
                        <Title ta='center'>{t('password.emailSent')}</Title>
                        <Text ta='center'>{t('password.resetPassword')}</Text>
                        <Center>
                            <Link to={'/login'}>
                                <Text>{t('action.backToLogin')}</Text>
                            </Link>
                        </Center>
                    </Card>
                </Container>
            </Center>
        )
    }

    return (
        <Center maw={400} mx="auto" h={height}>
            <Container maw={400}>
                <Card shadow="sm" padding="lg" radius="md" withBorder mb="md" mt="md">
                    <Center>
                        <IconKey color="blue" size={60} />
                    </Center>
                    <Title ta='center'>{t('password.forgotPassword')}</Title>
                    <Text ta='justify' fz="sm">{t('password.forgotPasswordMessage')}</Text>
                    <form id="forgot-password-form" onSubmit={handleSubmit}>
                        <TextInput
                            autoFocus
                            name='username'
                            label={t('user.username')}
                            {...form.getInputProps('username')}>
                        </TextInput>
                        <Center mt={8} mb={8}>
                            <Button 
                                type='submit'
                                form='forgot-password-form'
                                style={{ backgroundColor: '#ff0008', width: '100%'}}>
                                {t('action.send')}
                            </Button>
                        </Center>
                    </form>
                    <Center>
                        <Link to={'/login'}>
                            <Text>{t('action.backToLogin')}</Text>
                        </Link>
                    </Center>
                </Card>
            </Container>
        </Center>
    )


}